import React, { useEffect, useMemo, useState } from "react";
import { getCardImageCandidates, getCardPlaceholderLabel } from "../utils/cardImages";
import "./CardImage.css";

const CardImage = ({ card, className = "", compact = false }) => {
  const candidates = useMemo(() => getCardImageCandidates(card), [card]);
  const [resolvedSrc, setResolvedSrc] = useState("");

  useEffect(() => {
    let isActive = true;

    setResolvedSrc("");

    const tryCandidate = (index) => {
      if (!isActive || index >= candidates.length) return;

      const image = new window.Image();
      image.onload = () => {
        if (!isActive) return;
        if (image.naturalWidth > 0 && image.naturalHeight > 0) {
          setResolvedSrc(candidates[index]);
          return;
        }
        tryCandidate(index + 1);
      };
      image.onerror = () => {
        if (!isActive) return;
        tryCandidate(index + 1);
      };
      image.src = candidates[index];
    };

    tryCandidate(0);

    return () => {
      isActive = false;
    };
  }, [candidates]);

  const wrapperClassName = [
    "card-image-frame",
    compact ? "card-image-frame-compact" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      {resolvedSrc ? (
        <img
          className="card-image-element"
          src={resolvedSrc}
          alt={card?.name || "Card"}
          loading="lazy"
        />
      ) : (
        <div className="card-image-placeholder">
          <div className="card-image-placeholder-code">
            {getCardPlaceholderLabel(card)}
          </div>
          <div className="card-image-placeholder-name">{card?.name || "Card image"}</div>
        </div>
      )}
    </div>
  );
};

export default CardImage;
